import "@fontsource-variable/archivo/wdth.css";
import "@fontsource/public-sans/latin-400.css";
import "@fontsource/public-sans/latin-500.css";
import "@fontsource/public-sans/latin-600.css";
import "@fontsource/jetbrains-mono/latin-400.css";
import "@fontsource/jetbrains-mono/latin-500.css";
import "./styles/tokens.css";
import "./styles/app.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { ApiContext, ApiRequestError } from "./api/client";
import { createHttpClient } from "./api/http/httpClient";
import { createMockClient } from "./api/mock/mockClient";
import { router } from "./app/router";
import { applyTheme, readTheme } from "./app/theme";
import { getLocale } from "./i18n/core";
import { ToastProvider } from "./ui/Toasts";

applyTheme(readTheme());
document.documentElement.lang = getLocale();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 20_000,
      refetchOnWindowFocus: false,
      // Repete só falhas de rede e erros 5xx transitórios; 4xx e 501 não mudam repetindo.
      retry: (count, err) => count < 1 && (!(err instanceof ApiRequestError) || err.status === 0 || (err.status >= 500 && err.status !== 501)),
    },
  },
});

import { API_MODE } from "./app/mode";

// VITE_API_MODE=http usa a API real; o padrão (e o build de revisão) usa o mock.
const api = API_MODE === "http" ? createHttpClient() : createMockClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ApiContext.Provider value={api}>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </QueryClientProvider>
    </ApiContext.Provider>
  </StrictMode>,
);
